import axios from "../axios";

const getAuthMethods = async function (accessToken,bankName) {
    try {
        const response = await axios.get('bank/getAuthMethods', {
            headers: {
                'Authorization': accessToken
            },
            params: {
                bankName
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getAuthMethods;
